<!--Title Section-->
<app-title-jumbo title="Analytics" comment="360° analysis of your portfolio across a number of dimensions to measure the impact of factor-based diversification"></app-title-jumbo>

<div class="my-container">

<!--Synthesis Section-->
<section>
  <div class="container">
    <div class="offset-1 col-10">
      <mat-accordion *ngIf="currentCluster">
        <mat-expansion-panel [expanded]="false"
                             (opened)="panelOpenState = true"
                             (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ currentCluster.name }}
            </mat-panel-title>
            <mat-panel-description *ngIf="!panelOpenState">
              {{ currentCluster.investment_zone.name }} - {{ currentCluster.currency.name }} - {{ currentCluster.market_positions.name }}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="row">
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Portfolio</span>
              <span *ngIf="currentOriginal" class="float-right">{{ currentOriginal.name }}</span>
              <span *ngIf="!currentOriginal" class="float-right">Undefined</span>
            </div>
            <div class="col-6" style="line-height: 30px">
            </div>
            <div class="col-6" style="line-height: 30px">
              <div class="w-100" style="border-top:1px dotted grey"></div>
              <span style="color: grey"> Inception date </span>
              <span class="float-right">{{ currentCluster.inception_date | date:'d MMM y' }}</span>
              <br>
            </div>
            <div class="col-6" style="line-height: 30px">
              <div class="w-100" style="border-top:1px dotted grey"></div>
              <span style="color: grey"> As of </span>
              <span class="float-right">{{ currentCluster.last_date | date:'d MMM y' }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey"> Benchmark </span>
              <span class="float-right">{{ currentCluster.benchmark_name }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey"> Asset class </span>
              <span class="float-right"> {{ currentCluster.asset_class }} </span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey"> Investment zone </span>
              <span class="float-right">{{ currentCluster.investment_zone.name }}</span>
              <br>
              <div class="w-100" style="border-bottom:1px dotted grey"></div>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey"> Currency </span>
              <span class="float-right">{{ currentCluster.currency.name }}</span>
              <br>
              <div class="w-100" style="border-bottom:1px dotted grey"></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Card deck -->
      <div class="card-deck mt-3">

        <!-- Card Performance & Risk -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/011.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='performanceRisk'? 'rgb(118,168,255)' : 'grey'}"><i class="fab fa-sellsy fa-lg"></i>&nbsp;&nbsp;&nbsp; Performance & Risk</h4>
            <!--Text-->
            <p class="card-text">Many indicators on the portfolio with overview, absolute analysis and relative analysis. Some charts will help...</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='performanceRisk'">Performance & Risk</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Performance & Risk -->

        <!-- Card Factor Analysis -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/012.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='factor'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-chess-rook fa-lg"></i>&nbsp;&nbsp;&nbsp; Factor Analysis</h4>
            <!--Text-->
            <p class="card-text">Factor exposure on all available portfolios thanks to a 7 factors analysis. A visual representation helps on...</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='factor'">Factor Analysis</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Factor Analysis -->

        <!-- Card Robustness -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/013.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='robustness'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-hard-hat fa-lg"></i>&nbsp;&nbsp;&nbsp; Robustness</h4>
            <!--Text-->
            <p class="card-text">Robustness analysis proposes conditional performances, rolling statistics and simulations. Charts will help...</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='robustness'">Robustness</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Robustness -->

      </div>
      <!-- Card deck -->
    </div>
  </div>
</section>
<!--Synthesis Section-->

<!--Performance Section-->
<app-analytics-performance *ngIf="selectBlock=='performanceRisk'"
                           [originalPRA]="currentOriginal ? currentOriginal.performanceRiskAnalysis : undefined"
                           [benchmarkPRA]="currentBenchmark ? currentBenchmark.performanceRiskAnalysis : undefined"
                           [investablePRA]="currentInvestable ? currentInvestable.performanceRiskAnalysis : undefined"
                           [protectedPRA]="currentProtected ? currentProtected.performanceRiskAnalysis : undefined"
                           [currentCA]="currentPortfolio ? currentPortfolio.componentsAnalysis : undefined"
                           [inceptionDate]="currentCluster ? currentCluster.inception_date : undefined"
                           [lastDate]="currentCluster ? currentCluster.last_date : undefined"></app-analytics-performance>
<!--Performance Section-->

<!--Factor Analysis Section-->
<app-analytics-factor-analysis *ngIf="selectBlock=='factor'"
                               [styleBoxData]="styleBoxData"
                               [currentFA]="currentPortfolio ? currentPortfolio.factorAnalysis : undefined"
                               [currentOriginalPA]="currentOriginal ? currentOriginal.peerAnalysis : undefined"
                               [currentInvestablePA]="currentInvestable ? currentInvestable.peerAnalysis : undefined"
                               [currentProtectedPA]="currentProtected ? currentProtected.peerAnalysis : undefined"
                               [inceptionDate]="currentCluster ? currentCluster.inception_date : undefined"
                               [lastDate]="currentCluster ? currentCluster.last_date : undefined"></app-analytics-factor-analysis>
<!--Factor Analysis Section-->

<!--Robustness Section-->
<app-analytics-robustness *ngIf="selectBlock=='robustness'"
                          [originalRA]="currentOriginal ? currentOriginal.robustnessAnalysis : undefined"
                          [investableRA]="currentInvestable ? currentInvestable.robustnessAnalysis : undefined"
                          [protectedRA]="currentProtected ? currentProtected.robustnessAnalysis : undefined"
                          [inceptionDate]="currentCluster ? currentCluster.inception_date : undefined"
                          [lastDate]="currentCluster ? currentCluster.last_date : undefined"></app-analytics-robustness>
<!--Robustness Section-->

  <br>
</div>
